import React from "react"

export function HeadLayout({ seo }) {
  return (
    <>
      <title>{seo?.title}</title>
      <meta name="description" content={seo?.metaDesc} />
      <meta property="og:url" content={seo?.opengraphUrl} />
      <meta property="og:type" content={seo?.opengraphType} />
      <meta property="og:title" content={seo?.opengraphTitle} />
      <meta property="og:description" content={seo?.opengraphDescription} />
      <meta property="og:image" content={seo?.opengraphImage?.sourceUrl} />
      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-eu1.hs-scripts.com/25527340.js"
      />
    </>
  )
}
